var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoundPath = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 1C17.75 0.585786 17.4142 0.25 17 0.25C16.5858 0.25 16.25 0.585786 16.25 1H17.75ZM5 1L0.669873 8.5H9.33013L5 1ZM16.25 1V11H17.75V1H16.25ZM5.75 11V7.75H4.25V11H5.75ZM11 16.25C8.10051 16.25 5.75 13.8995 5.75 11H4.25C4.25 14.7279 7.27208 17.75 11 17.75V16.25ZM16.25 11C16.25 13.8995 13.8995 16.25 11 16.25V17.75C14.7279 17.75 17.75 14.7279 17.75 11H16.25Z",
    fill: "#3030AD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoundPath);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/roundPath.d4bf90bcc17e122cdab728067ff0cf00.svg";